import { useSelector, useDispatch } from 'react-redux'

import { setHelpTabState, setHelpTabFaq } from 'app/redux/widget/widget.actions'
import { LeftArrow } from 'app/components/icons'

const getFaqs = ({ widgetData }) => widgetData.widgetInfo.faq
const getLanguageInfo = ({ widgetData }) => widgetData.widgetInfo.languageInfo

function FAQList() {
  const faqs = useSelector(getFaqs)
  const languageInfo = useSelector(getLanguageInfo)

  const faqsCount = faqs.length
  const dispatch = useDispatch()

  const handleSetTabState = (state) => {
    dispatch(setHelpTabState(state))
  }

  const handleShowfaqDetail = (faq) => () => {
    handleSetTabState('FAQ_DETAIL')
    dispatch(setHelpTabFaq(faq))
  }

  return (
    <>
      {/* faqs list */}
      <div className="help_tab_body_heading">{`${faqsCount} ${languageInfo.texts.collections} `}</div>
      <div className="help_tab_body_faq_list">
        {faqs.map((faq, index) => {
          return (
            <div onClick={handleShowfaqDetail(faq)} className="help_tab_body_faq_item" key={index}>
              <div className="help_tab_body_faq_item_content">
                <span className="help_tab_body_faq_item_title">{faq.title}</span>
                <span className="help_tab_body_faq_item_description">{faq.description}</span>
              </div>
              <div className="help_tab_body_faq_item_arrow">
                <LeftArrow />
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default FAQList
